import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import eventsHero from "../assets/events-hero.jpg";
import { Link } from "react-router-dom";
import logo from "../assets/burgersson-logo.png";

const tillval = [
  "Kaffe eller te samt glasskula från Lejonet & Björnen 60:-/ person",
  "Välkomstbubbel 89:-/ glas",
  "Flaska Prosecco 295:-",
  "Flaska Husets Röda 295:-",
  "Flaska Husets Vita 295:-",
  "Hink med 5 Peroni 295:-",
];

const Events = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="relative w-full h-screen min-h-[600px] flex items-end overflow-hidden">
        <img
          src={eventsHero}
          alt="Events at Burgersson"
          className="absolute inset-0 w-full h-full object-cover"
          width={1920}
          height={1080}
        />
        <div className="hero-overlay absolute inset-0" />
        <div className="relative z-10 px-6 md:px-16 pb-20 fade-in-up max-w-5xl">
          <h1
            className="font-heading text-2xl md:text-4xl lg:text-5xl tracking-wide text-foreground uppercase mb-8"
            style={{ lineHeight: "1.3" }}
          >
            Aktiviteter / Teambuilding / Företagsbokning / Större Sällskap
          </h1>
          <p className="font-body text-sm text-muted-foreground max-w-3xl uppercase tracking-wide leading-relaxed">
            Burgersson Skanstorget samarbetar med OnAir Gameshows på Övre
            Husargatan 14
          </p>
          <p className="font-body text-sm text-muted-foreground max-w-3xl uppercase tracking-wide mt-2">
            som ligger ett stenkast från vår restaurang på Skanstorget.
          </p>
          <p className="font-body text-sm text-muted-foreground max-w-3xl uppercase tracking-wide mt-4">
            OnAir: Boka paket med middag på Burgersson Skanstorget och aktivitet
            på OnAir Gameshows
          </p>
        </div>
      </section>
      <section
        className="relative overflow-hidden py-24 px-6 md:px-16"
        style={{ backgroundColor: "#A8ADA9" }}
      >
        {/* Giant watermark logo in background */}
        <div
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          aria-hidden="true"
        >
          <img
            src={logo}
            alt=""
            className="w-full h-full object-cover opacity-5"
            style={{ filter: "grayscale(100%)" }}
          />
        </div>
        <div className="max-w-4xl mx-auto text-center">
          <p className="font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] uppercase tracking-wide leading-[1.8] mb-10">
            Vill ni ha ett event hos oss? Är ni ett företag eller ett större
            sällskap på fler än 12 personer så skräddarsyr vi menyn just för er.
          </p>
          <p className="font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] uppercase tracking-wide mb-4">
            – Ni får välja på ett urval av burgare från menyn, burgarna steks
            medium well eller well done om så önskas.
          </p>
          <p className="font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] uppercase tracking-wide mb-14">
            – Vi löser en schysst blandning av våra olika pommes och dippsåser.
          </p>
          <h2 className="font-heading text-xl md:text-3xl tracking-wide text-[hsl(var(--surface-light-foreground))] uppercase mb-8 leading-[1.15]">
            Tillval:
          </h2>
          <div className="flex flex-col gap-3 mb-14">
            {tillval.map((item) => (
              <p
                key={item}
                className="font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] uppercase tracking-wide"
              >
                {item}
              </p>
            ))}
          </div>
          <p className="font-body text-sm md:text-base text-[hsl(var(--surface-light-foreground)/.8)] mb-8">
            Vill ni veta mera eller boka så kontakta oss
          </p>
          <Link
            to="#"
            className="inline-block px-8 py-3 rounded-full border border-[hsl(var(--surface-light-foreground)/.4)] text-xs font-body font-medium uppercase tracking-widest text-[hsl(var(--surface-light-foreground))] hover:bg-[hsl(var(--surface-light-foreground))] hover:text-[hsl(var(--surface-light))] transition-all duration-300"
          >
            Kontakta Oss
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Events;
